<div
  class="angular-tags-input"
  [ngClass]="config.defaultClass + ' ' + config.additionalClasses">
  <div class="angular-tags-input__inp-container" #dropdownTrigger="cdkOverlayOrigin" cdkOverlayOrigin>
    <ng-container *ngIf="!config.hideTags">
      <ti-tag
        class="angular-tags-input__inp-container__tag"
        *ngFor="let tagItem of tags"
        [config]="config"
        [tagItem]="tagItem"
        [tagItemTemplate]="tagItemTemplate"
        (closeClicked)="tagCloseClicked($event)">
      </ti-tag>
    </ng-container>
    <ti-tag-input
      [style.display]="config.hideInputOnSelection && tags.length ? 'none' : 'block'"
      [config]="config"
      [disabled]="disabled"
      class="angular-tags-input__inp-container__tag-input"
      (tagEntered)="addTag($event)"
      (valueChanged)="onInputValueChanged($event)"
      (inputFocused)="onInputFocus()"
      (inputBlurred)="onFocusChange(false);"
      (inputKeyPress)="inputKeyPress($event)"
      (keydown)="hideDropdownOnTab($event)">
    </ti-tag-input>
  </div>
  
  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="dropdownTrigger" [cdkConnectedOverlayOpen]="isDropdownOpen"
    [cdkConnectedOverlayHasBackdrop]="config.ddHasBackdrop" (backdropClick)="hideDropdown()"
    [cdkConnectedOverlayPanelClass]="'angular-tags-input-dd-overlay' + config.dropdownClass ? config.dropdownClass : ''"
    [cdkConnectedOverlayScrollStrategy]="ddScrollStrategy"
    [cdkConnectedOverlayPositions]="dropdownOverlayPosition"
    [cdkConnectedOverlayMinWidth]="310">
    <div class="angular-tags-input__dd-container">
      <ti-dropdown
        [inputVal]="inputVal"
        (itemClicked)="onItemClicked($event);"
        [dropDownTemplate]="dropDownTemplate"
        [listItems]="tagsData | unAddedTags: {tagsAdded: tags, config: config}"
        [config]="config"
        (itemAdded)="addTag($event);">
      </ti-dropdown>
    </div>
  </ng-template>
</div>
